import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/ApiClient';

const PLANS = [
  { key: 'monthly',   label: 'Monthly',    price: 15, desc: '$15 / month' },
  { key: 'quarterly', label: 'Quarterly',  price: 39, desc: '$39 / 3 months' },
  { key: 'annual',    label: 'Annual',     price: 99, desc: '$99 / year', best: true },
];

export default function Subscriptions() {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [plan, setPlan] = useState('monthly');

  const load = () => {
    setLoading(true);
    api.getSubscriptions().then(d => setSubs(d.subscriptions || [])).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const handleCancel = async (id) => {
    if (!window.confirm('Cancel this subscription?')) return;
    try { await api.cancelSubscription(id); load(); } catch { alert('Failed'); }
  };

  const handleSubscribe = async () => {
    const p = PLANS.find(x => x.key === plan);
    try {
      await api.createSubscription({ plan: p.key, price: p.price, category: 'nlp' });
      setShowForm(false);
      load();
    } catch (err) { alert(err?.response?.data?.message || 'Failed'); }
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text)', letterSpacing: '-0.5px' }}>Subscriptions</h1>
        <button onClick={() => setShowForm(!showForm)} className="btn-primary" style={{ fontSize: 13 }}>
          New subscription
        </button>
      </div>

      {/* Plan picker */}
      {showForm && (
        <div className="card" style={{ padding: 24, marginBottom: 20 }}>
          <h2 style={{ fontSize: 15, fontWeight: 600, color: 'var(--text)', marginBottom: 16 }}>Choose a plan</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 20 }}>
            {PLANS.map(p => (
              <div key={p.key} onClick={() => setPlan(p.key)} style={{
                padding: '16px', borderRadius: 8, cursor: 'pointer',
                border: `2px solid ${plan === p.key ? 'var(--accent)' : 'var(--border)'}`,
                background: plan === p.key ? 'var(--accent-bg)' : 'var(--surface)',
                position: 'relative',
              }}>
                {p.best && (
                  <span style={{ position: 'absolute', top: -8, right: 10, fontSize: 10, padding: '2px 8px', borderRadius: 10, background: '#D97706', color: '#fff', fontWeight: 700 }}>
                    Best value
                  </span>
                )}
                <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--text)', marginBottom: 4 }}>{p.label}</div>
                <div style={{ fontSize: 13, color: 'var(--accent)', fontFamily: 'Space Mono' }}>{p.desc}</div>
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <button onClick={handleSubscribe} className="btn-primary" style={{ fontSize: 13 }}>
              Subscribe — ${PLANS.find(p => p.key === plan)?.price}
            </button>
            <button onClick={() => setShowForm(false)} className="btn-secondary" style={{ fontSize: 13 }}>Cancel</button>
          </div>
        </div>
      )}

      {loading && <div style={{ color: 'var(--text-3)' }}>Loading…</div>}

      {!loading && subs.length === 0 && (
        <div className="card" style={{ padding: '60px 24px', textAlign: 'center' }}>
          <p style={{ color: 'var(--text-2)' }}>No active subscriptions.</p>
        </div>
      )}

      {!loading && subs.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14 }}>
          {subs.map(s => {
            const a = s.assetId || {};
            const daysLeft = Math.max(0, Math.ceil((new Date(s.endDate) - new Date()) / 86400000));
            return (
              <div key={s._id} className="card" style={{ padding: 20 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--text)' }}>
                    {a.title
                      ? <Link to={`/asset/${a._id}`} style={{ color: 'var(--text)', textDecoration: 'none' }}>{a.title}</Link>
                      : s.category || s.assetType || 'All content'
                    }
                  </div>
                  <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 4, fontWeight: 600, textTransform: 'capitalize', background: 'var(--accent-bg)', color: 'var(--accent)' }}>
                    {s.plan}
                  </span>
                </div>
                <div style={{ fontSize: 12, color: daysLeft <= 7 ? 'var(--danger)' : 'var(--text-3)', marginBottom: 10 }}>
                  {daysLeft} days left · expires {new Date(s.endDate).toLocaleDateString()}
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: 12, color: 'var(--text-3)' }}>
                    {s.autoRenew ? 'Auto-renew on' : 'Auto-renew off'}
                  </span>
                  <button onClick={() => handleCancel(s._id)} style={{
                    padding: '4px 12px', borderRadius: 6, background: 'var(--danger-bg)',
                    color: 'var(--danger)', border: '1px solid #FECACA', cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: 'inherit',
                  }}>Cancel</button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
